import alt from "../alt";

class ItemBucketActions {
  constructor() {
    this.generateActions("updateItemBuckets", "fetchAll");
  }
}

export default alt.createActions(ItemBucketActions);



// WEBPACK FOOTER //
// ./src/app/actions/ItemBucketActions.js